// Styles for OffersMultiplier go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { font, mediaQuery } from '../../utils/styles';

export const StyledOffersMultiplier = styled.div`
  .offermultiplier-container {
    width: 100%;
    padding-bottom: ${toRem(64)};
    padding-top: ${toRem(64)};

    @media ${mediaQuery.tabletMax} {
      padding-bottom: ${toRem(48)};
      padding-top: ${toRem(48)};
    }

    @media ${mediaQuery.tabletOnly} {
      padding-bottom: ${toRem(48)};
      padding-top: ${toRem(48)};
    }

    @media ${mediaQuery.mobileOnly} {
      padding-top: ${toRem(48)};
      padding-bottom: ${toRem(48)};
    }
    .offermultiplier-wrapper {
      @media ${mediaQuery.mobileOnly} {
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
      }
      border-radius: 14px;
      border: 1px solid var(--Colors-neutral-20, #eee);
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.07);
      justify-items: center;
      padding: ${toRem(48)};
      @media ${mediaQuery.tabletMax} {
        padding: ${toRem(32)};
      }
      .multiplier-center {
        @media ${mediaQuery.desktop} {
          width: ${toRem(752)};
        }

        display: flex;
        flex-direction: column;
        .multiplier-title {
          font-family: ${font.Swiss721BTRegular};
          font-style: normal;
          font-weight: 700;
          text-transform: capitalize;
          padding-bottom: ${toRem(48)};
          @media ${mediaQuery.tabletMax} {
            font-size: ${toRem(35)};
            padding-bottom: ${toRem(32)};
          }
        }

        div {
          font-size: ${toRem(16)};
          .points-rounded {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: ${toRem(34)};
            width: 100px;
            height: 100px;
            font-family: ${font.Swiss721BTRegular};
            font-weight: 900;
          }

          .offers-pointscard div {
            padding-bottom: 0px !important;
            padding-top: 0px !important;
            .t-font-s {
              @media ${mediaQuery.mobileOnly} {
                margin-bottom: 0px !important;
              }
            }
          }
        }
      }
    }
  }
  .multiplier-center > div {
    padding-bottom: 24px;
  }
  .multiplier-center > div:last-child {
    padding-bottom: 0px;
  }
`;
